export default {
  FETCH_ORIGIN_LOCATIONS: '@LOCATIONS/FETCH__ORIGIN_LOCATIONS',
  FETCH_ORIGIN_LOCATIONS_SUCCESS: '@LOCATIONS/FETCH__ORIGIN_LOCATIONS_SUCCESS',
  LOAD_MORE_ORIGIN_LOCATIONS: '@LOCATIONS/LOAD_MORE_ORIGIN_LOCATIONS',
  SET_ORIGIN_LOCATIONS_FILTERS: '@LOCATIONS/SET_ORIGIN_LOCATIONS_FILTERS',
  START_ORIGIN_LOCATIONS_REQUEST: '@LOCATIONS/START_ORIGIN_LOCATIONS_REQUEST',

  FETCH_DESTINATION_LOCATIONS: '@LOCATIONS/FETCH__DESTINATION_LOCATIONS',
  FETCH_DESTINATION_LOCATIONS_SUCCESS: '@LOCATIONS/FETCH_DESTINATION_LOCATIONS_SUCCESS',
  LOAD_MORE_DESTINATION_LOCATIONS: '@LOCATIONS/LOAD_MORE_DESTINATION_LOCATIONS',
  SET_DESTINATION_LOCATIONS_FILTERS: '@LOCATIONS/SET_DESTINATION_LOCATIONS_FILTERS',
  START_DESTINATION_LOCATIONS_REQUEST: '@LOCATIONS/START_DESTINATION_LOCATIONS_REQUEST'
}
